import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=2bc6b60a&"
import script from "./Session.vue?vue&type=script&lang=js&"
export * from "./Session.vue?vue&type=script&lang=js&"
import style0 from "./Session.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Session.vue"
export default component.exports